import { z } from 'zod';

export const PointSchema = z.object({
    x: z.number(),
    y: z.number(),
});
